export default "__VITE_ASSET__B8M2f1JR__"